import hash from './hash';
import HostChannel from './HostChannel';
import MultiplexChannel from './MultiplexChannel';
const CHANNEL_PASSTHROUGH = ['connected', 'failed', 'reconnecting', 'up', 'down', 'switching'];
/**
 * Manages subscriptions to channels within a multiplexed connection (via HostChannel)
 */
export default class MultiplexHost {
    constructor(options) {
        this.openChannels = {};
        this.host = new HostChannel('/channels@firehose', {
            ssl: options.ssl,
            host: options.host
        });
        this.host.on('message', (message, frame) => {
            const channel = this.openChannels[hash(frame.channel)];
            if (channel) {
                channel.lastMessageSequence = frame.last_sequence;
                channel.emit('message', message, frame);
            }
            else {
                console.log(`Dropping message to closed channel: ${frame.channel}`);
            }
        });
        this.host.on('error', (error = {}, frame) => {
            const channel = this.openChannels[hash(frame.channel)];
            if (channel) {
                if (error.type === 'UnauthorizedSubscription') {
                    channel.emit('failed', error, frame);
                }
                else if (error.type === 'ExpiredSubscription') {
                    this.reconnectToChannel(channel);
                }
                else {
                    channel.emit('error', error, frame);
                }
            }
            else {
                console.log(`Dropping error (${error.type}) to closed channel: ${frame.channel}`);
            }
        });
        CHANNEL_PASSTHROUGH.forEach((eventName) => {
            this.host.on(eventName, (...args) => {
                for (const key in this.openChannels) {
                    if (this.openChannels.hasOwnProperty(key)) { // eslint-disable-line no-prototype-builtins
                        this.openChannels[key].emit(eventName, ...args);
                    }
                }
            });
        });
    }
    openChannel(channelPath, options) {
        const key = hash(channelPath);
        if (this.openChannels[key]) {
            this.openChannels[key].subscribe();
        }
        else {
            this.openChannels[key] = new MultiplexChannel(this.host, channelPath, options);
            this.openChannels[key].once('destroy', () => {
                delete this.openChannels[key];
            });
        }
        return this.openChannels[key];
    }
    reconnectToChannel(channel) {
        const preflight = channel.options.preflight
            ? channel.options.preflight()
            : Promise.resolve();
        channel.emit('reconnecting');
        this.host.unsubscribeFromChannel(channel);
        preflight
            .then(() => {
            this.host.subscribeToChannel(channel);
        })
            .catch((e) => {
            channel.emit('failed', 'Reconnection failed', e);
        });
    }
}
//# sourceMappingURL=MultiplexHost.js.map